<template>
    <v-row dense align="center" align-content="center" justify="center">
        <v-col cols="2" class="text-right">
            <span class=" body-1 mt-0 pt-0"> {{this.title}} </span>                                                                                    
        </v-col>
        <v-col cols="1">
            <v-text-field :rules="[rules.required]" v-model="t1" type="time" hide-details dense class="mt-0 pt-0 pl-2"></v-text-field>
        </v-col>
        <v-col cols="1">
            <v-text-field :rules="[rules.required]" v-model="t2" type="time" hide-details dense class="ml-4 mt-0 pt-0"></v-text-field>
        </v-col> 
        <v-col cols="3" class="text-center">
            <span>Intervalo</span>
        </v-col>                                        
        <v-col cols="1">
            <v-text-field v-model="t3" type="time" hide-details dense class="mt-0 pt-0"></v-text-field>
        </v-col>
        <v-col cols="1">
            <v-text-field v-model="t4" type="time" hide-details dense class="ml-4 mt-0 pt-0"></v-text-field>
        </v-col> 
        <v-col cols="2" class="text-center">
            <v-btn color="primary" fab x-small dark @click="saveConfig('whatsapp',whatsapp)">
                <v-icon>mdi-content-save</v-icon>
            </v-btn>        
        </v-col>                                                                                           
    </v-row>
</template>

<script>
import {db} from '@/main'
import dbFunctions from "@/dbFunctions"
import store from "@/store"

export default {
    props:['title', 'abrev', 'valor'],  
    data: () => ({
        rules: {
            required: value => !!value || 'Campo Obrigatório.',        
        },
        items: [],
        selected: [],
        dayofweek: false,
        t1: '',
        t2: '',
        t3: '',
        t4: '',
        companyId: ''
    }),   
    created(){
        this.companyId = this.$store.getters.company.data.id
        this.getDataInfo = dbFunctions.getDataInfo
        this.t1 = this.valor[0]
        this.t2 = this.valor[1]
        this.t3 = this.valor[2]
        this.t4 = this.valor[3]

    },    
    methods: {
        saveConfig(){

            let configAtendimento = []
            configAtendimento['horarios'] = this.$store.getters.company.data.horarios
            configAtendimento['horarios'][this.abrev] = [this.t1,this.t2,this.t3 || false ,this.t4 || false]

            console.log("Salvando", configAtendimento)
            db.collection('empresas').doc(this.companyId).update(configAtendimento).then(async() => {
                    this.loading = false
                    let success = {
                        'active':true,
                        'color':'success',
                        'message':'Configuração Atualizada com Sucesso'
                    }                
                    await this.reloadData(this.$store.getters.company.data.id)
                    this.$emit("loadMessage",success)
                    // this.$emit("listEdit")
                    // this.clearFields()
                }).catch(function (error) {
                    let errorMessage = {
                        'active':true,
                        'color':'error',
                        'message': error
                    }          
                    console.error('Error to Save Config - AttendPage: ' + error)
                    this.$emit("loadMessage",errorMessage)            
            })
        },
        async reloadData(companyId){
            let dataStore = await this.getDataInfo(companyId)
            store.dispatch("fetchData",dataStore)
        },         
    } 
}
</script>